import { render } from "./PackageLists.vue?vue&type=template&id=4ab9f70e&ts=true"
import script from "./PackageLists.vue?vue&type=script&lang=ts"
export * from "./PackageLists.vue?vue&type=script&lang=ts"

import "./PackageLists.vue?vue&type=style&index=0&id=4ab9f70e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__